import { render, staticRenderFns } from "./SeizureModal.vue?vue&type=template&id=25e7eba1&"
import script from "./SeizureModal.vue?vue&type=script&lang=js&"
export * from "./SeizureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports